import { Button, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import ActivateUserModal from "./ActivateUserModal";
import EditUserModal from "./EditUserModal";
import PasswordModal from "./PasswordModal";

const Actions = () => {
  const { cognitoCredentialsUser, isUserActive, fetchPaises } =
    useSingleUserControl();

  const [isActivateOpen, setIsActivateOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isChangePassOpen, setIsChangePassOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOption = (option: string) => {
    console.log("Opción seleccionada:", option);
    if (option === "Activar usuario") {
      setIsActivateOpen(true);
    } else if (option === "Editar") {
      fetchPaises();
      setIsEditOpen(true);
    } else if (option === "Cambiar contraseña") {
      setIsChangePassOpen(true);
    }
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        sx={{
          backgroundColor: "#336B87",
          color: "white",
          borderRadius: "20px", // Más redondeado
          textTransform: "none",
        }}
      >
        Acciones
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { mt: "6px" }, // Baja el menú 6px
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => !isUserActive && handleOption("Activar usuario")}
          disabled={isUserActive}
        >
          Activar usuario
        </MenuItem>

        <MenuItem onClick={() => handleOption("Editar")}>Editar</MenuItem>

        <MenuItem
          onClick={() =>
            cognitoCredentialsUser && handleOption("Cambiar contraseña")
          }
          disabled={!cognitoCredentialsUser}
        >
          Cambiar contraseña
        </MenuItem>
      </Menu>

      {/* Modal para activar usuario */}
      <ActivateUserModal
        isOpen={isActivateOpen}
        setIsOpen={setIsActivateOpen}
      />

      {/* Modal para editar usuario */}
      <EditUserModal isOpen={isEditOpen} setIsOpen={setIsEditOpen} />

      {/* Modal para cambiar contraseña */}
      <PasswordModal
        isOpen={isChangePassOpen}
        setIsOpen={setIsChangePassOpen}
      />
    </>
  );
};

export default Actions;
